import React from 'react';
import Container from 'react-bootstrap/Container';
import Page from '../page/Page'
import English from '/static/i18n/en.json';
import Bengali from '/static/i18n/bn.json';
import { useAuth } from '../../hooks/auth/AuthContext';

const locale = navigator.language;

let lang;
if (locale === "en") {
    lang = English;
} else {
    lang = Bengali;
}

const CardGrid = ({ children,style }) => {
    const { loggedIn } = useAuth();
    return (
        <>
            {children}
        </>
    );
};

export default CardGrid;